var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "detail" }, [
    _vm.consignmentDetail.data.status
      ? _c("div", { staticClass: "not-found" }, [
          _vm._v(
            "\t\t\t\n        " +
              _vm._s(_vm.consignmentDetail.data.status) +
              ", please try again.\n    "
          ),
        ])
      : _c(
          "div",
          [
            _c("banner-notification", {
              attrs: {
                header: _vm.consignmentDetail.data.notificationHeader,
                notification: _vm.consignmentDetail.data.notification,
              },
            }),
            _vm._v(" "),
            _vm.consignmentScans
              ? _c("tracking-status", {
                  attrs: { trackingstatus: _vm.trackingDetail },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("tracking-summary", {
              attrs: {
                consignmentNote: _vm.consignmentDetailSummary.ConsignmentNote,
                consigned: _vm.formatDate(
                  _vm.consignmentDetailSummary.Released,
                  "YYYY-MM-DD"
                ),
                reference: _vm.consignemntReferences,
                sender: _vm.consignmentDetailSummary.SenderLocation,
                receiver: _vm.consignmentDetailSummary.ReceiverLocation,
                eta: _vm.formatDateETA(
                  _vm.consignmentDetailSummary.ETA,
                  "YYYY-MM-DD"
                ),
              },
            }),
            _vm._v(" "),
            _c("tracking-carrier", {
              attrs: {
                carrierName: _vm.consignmentDetailSummary.CarrierName,
                trackingPage: _vm.consignmentDetailSummary.CarrierTrackingPage,
                consignmentNote: _vm.consignmentDetailSummary.ConsignmentNote,
              },
            }),
            _vm._v(" "),
            _c("tracking-items", {
              attrs: {
                noItems: _vm.consignmentDetailSummary.Items.length,
                weight: _vm.consignmentDetailSummary.Weight,
                volume: _vm.consignmentDetailSummary.Volume,
              },
            }),
            _vm._v(" "),
            _c("tracking-details", {
              attrs: {
                items: _vm.consignmentDetailSummary.Items,
                scans: _vm.consignmentScans,
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }